import { lazy } from "react";
import {
  enumPermisosAuditoriaLogs,
} from "./enumPermisos";
/** Componente de iconos */
const AppIcons = lazy(() => import("../../components/Base/AppIcons"));


const TablaAuditoria = lazy(() =>
  import("./Views/PrincipalAuditoria/TablaAuditoria")
);


const listPermissions = Object.values(enumPermisosAuditoriaLogs);

export const listPermissionsAuditoriaLogs = listPermissions;

const routesAuditoriaLogs = {
  link: "/GestionTransaccional/auditoria-logs",
  label: <AppIcons Logo={"AUDITORIA_LOGS"} name='Auditoria' />,
  component: TablaAuditoria,
  permission: [enumPermisosAuditoriaLogs.AUDITORIA_LOGS],
};

export default routesAuditoriaLogs;
